// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2yYoX","bigColWidth":"Table_bigColWidth__1iS1P","biggerColWidth":"Table_biggerColWidth__l15aW","row":"Table_row__1Pkzg","col":"Table_col__3brUQ"};